<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { HfarmCorporate } from "../../modules/hfarm_corporate_module.js";
import "magnific-popup";
import VueButton from "vue-button";

export default {
  mixins: [fandomBasicMixin],
  components: {
    VueButton
  },
  data: function () {
    return {
      popupOpen: false
    };
  },
  mounted: function () {
    Vue.nextTick(() => {
      if (!this.content.url) {
        $(`#${this.content.$id}-${this.popupId}-popup-link`).magnificPopup({
          items: {
            src: `#${this.content.$id}-${this.popupId}-popup`,
            type: 'inline'
          },
          removalDelay: 300,
          mainClass: 'mfp-fade',
          callbacks: {
            open: () => {
              setTimeout(() => {
                this.popupOpen = true;
              }, 200)
            },
            close: () => {
              this.popupOpen = false;
            }
          }
        });

        if (HfarmCorporate.isTypeformScriptInContentButtons(this.content)) {
          HfarmCorporate.initTypeformScript();
        }
      }
    });
  },
  computed: {
    link() {
      return this.content.url ? this.content.url.url : `${this.content.$id}-${this.popupId}-popup`;
    },
    popupId() {
      const str = this.content.member_name || this.content.title;
      return str.replace(' ', '');
    }
  },
  methods: { }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" v-if="isContentVisibleToUser()">
    <a :id="`${content.$id}-${popupId}-popup-link`" :href="link" :target="getTarget(content.url)">
      <slot></slot>
    </a>
    <div 
      :id="`${content.$id}-${popupId}-popup`"
      :key="`${content.$id}-${popupId}-popup`"
      class="mfp-hide"
      people-popup-component
    >
      <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
        <div v-if="popupOpen" class="container d-flex flex-column justify-content-center align-items-begin">
          <img
            v-if="content.image"
            :src="content.image.url"
            class="rounded-circle photo mt-3"
          >
          <h2 v-if="content.title" class="mb-0 mt-4">{{ content.title}}</h2>
          <h3 v-if="content.subtitle" class="subtitle mb-0">{{ content.subtitle }}</h3>
          <p v-if="content.description" class="mt-3 pt-3" v-html="content.description"></p>
          <div>
            <vue-button
              tag="a"
              v-if="content.button" 
              :button="content.button"
              :buttonClass="['btn shadow-none', getPrimaryButtonClass(content.button_class, content.theme)]" 
            ></vue-button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="scss">
[people-popup-component] {

  background: $white;
  width: 100vw;
  margin-left: -.5rem;
  margin-right: -.5rem;
  padding: 10% 15%;
  font: MaisonNeue,Arial,sans-serif;
  min-height: 100vh;

  .mfp-close {
    margin-top: 1.25rem;
    margin-right: 1.25rem;
    transition: all .2s;
    position: fixed;
    &:focus { outline: 0; }
  }

  .photo {
    width: 4.75rem;
    height: 4.75rem;
  }

  .subtitle {
    font-size: 1.75rem;
    line-height: 2.375rem;
    font-weight: 100;
  }

}

</style>
